module.exports = __webpack_public_path__ + "img/3.7e22a082.jpg";